import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import CustomSidePanel from "../../../../../components/blank-side-pannel/custom-side-pannel";
import { BlueGradientButton } from "../../../../../components/button";
import * as accountCampaignPricingEmailActions from "../../../store/actions/account_campaign_pricing_email_actions";

export default function AccountCampaignPricingEmailSidePanel({ show, pricingData, handleClose }) {
  const [formData, setFormData] = useState({});
  const dispatch = useDispatch();
  const params = useParams();

  useEffect(() => {
    const { addOnAttachmentPrice, addOnPrice, price, attachmentPrice } = pricingData || {};
    const tempFormData = {
      addOnAttachmentPrice,
      addOnPrice,
      price: price,
      attachmentPrice: attachmentPrice,
      finalPrice: ((addOnPrice || 0) + (price || 0)).toFixed(4),
      finalAttachmentPrice: ((addOnAttachmentPrice || 0) + (attachmentPrice || 0)).toFixed(4),
    };
    setFormData(tempFormData);
  }, [pricingData]);

  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      id: params.accountId,
      loadingData: { id: params.accountId },
      data: {
        addOnAttachmentPrice: formData.addOnAttachmentPrice,
        addOnPrice: formData.addOnPrice,
      },
    };
    dispatch(accountCampaignPricingEmailActions.editPricingOfAccountEmailCampaignRequest(payload));
    handleClose();
  };

  const handleChange = (inputKey, _inputValue) => {
    const inputValue = typeof _inputValue === "number" ? _inputValue : Number(_inputValue);
    if (inputKey === "addOnPrice") {
      setFormData((prev) => {
        return {
          ...prev,
          [inputKey]: inputValue,
          finalPrice: ((inputValue || 0) + (prev.price || 0)).toFixed(4),
        };
      });
    }
    else if (inputKey === "addOnAttachmentPrice") {
      setFormData((prev) => {
        return {
          ...prev,
          [inputKey]: inputValue,
          finalAttachmentPrice: ((inputValue || 0) + (prev.attachmentPrice || 0)).toFixed(4),
        };
      });
    }
    else if (inputKey === "finalPrice") {
      setFormData((prev) => {
        return {
          ...prev,
          [inputKey]: inputValue,
          addOnPrice: ((inputValue || 0) - (prev.price || 0)).toFixed(4),
        };
      });
    }
    else if (inputKey === "finalAttachmentPrice") {
      setFormData((prev) => {
        return {
          ...prev,
          [inputKey]: inputValue,
          addOnAttachmentPrice: ((inputValue || 0) - (prev.attachmentPrice || 0)).toFixed(4),
        };
      });
    }
  };

  return (
    <CustomSidePanel
      title={`Email Pricing(${pricingData.currency})`}
      show={show}
      moduleName="Campaign Pricing - Email"
      handleClose={handleClose}
      customStyles={{
        width: "50vw",
        right: "51vw",
      }}
    >
      <div className="card-header d-flex flex-stack align-items-center">
        <h3 className="card-title fw-bolder text-dark">{`Email Pricing(${pricingData.currency})`}</h3>
      </div>
      <div style={{ height: "calc(100vh - 70px)", overflowY: "auto" }} className="p-8">
        <FormDisplay {...{ formData, handleChange, handleClose, handleSubmit }} />
      </div>
    </CustomSidePanel>
  );
}

const FormDisplay = ({ formData, handleChange, handleClose, handleSubmit }) => {
  return (
    <Form onSubmit={handleSubmit} noValidate>
      {/* <Row>
        <Col className="form-group" xs={6}>
          <label className="form-label text-gray-700">Additional Price Per Email</label>
          <Form.Control type="number" value={formData.addOnPrice ?? 0} onChange={(e) => handleChange("addOnPrice", e.target.value)} />
        </Col>
        <Col className="form-group" xs={6}>
          <label className="form-label text-gray-700">Additional Attachment Price Per Email</label>
          <Form.Control type="number" value={formData.addOnAttachmentPrice ?? 0} onChange={(e) => handleChange("addOnAttachmentPrice", e.target.value)} />
        </Col>
      </Row> */}

      <Row>
        <Col className="form-group" xs={6}>
          <label className="form-label text-gray-700">Final Price Per Email</label>
          <Form.Control type="number" value={formData.finalPrice ?? 0} onChange={(e) => handleChange("finalPrice", e.target.value)} />
        </Col>
        <Col className="form-group" xs={6}>
          <label className="form-label text-gray-700">Final Attachment Price Per Email</label>
          <Form.Control type="number" value={formData.finalAttachmentPrice ?? 0} onChange={(e) => handleChange("finalAttachmentPrice", e.target.value)} />
        </Col>
      </Row>

      <Form.Group className="d-flex gap-3 mt-10">
        <Button type="button" size="sm" variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <BlueGradientButton size="sm" type="submit">
          Save
        </BlueGradientButton>
      </Form.Group>
    </Form>
  );
};
